// Regalo automático del Pack de 3 (Lámpara Solar Exterior 150W): si el
// carrito tiene esa variante, se agrega gratis (vía descuento automático
// de Shopify) el Set de 10 Luces Solares de Jardín; si el Pack de 3 sale
// del carrito, el regalo se quita. Solo toca la línea que él mismo
// agregó (propiedad oculta _regalo_pack3), nunca una compra normal de
// ese producto.
(function () {
  var VARIANTE_DISPARADORA = 54068206633243; // Pack de 3
  var VARIANTE_REGALO = 52799967199515; // Set de 10 Luces Solares de Jardín
  var sincronizando = false;

  function pintarCarrito(secciones) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && secciones && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: secciones });
    }
  }

  function pedir(url, cuerpo) {
    cuerpo.sections = 'cart-drawer,cart-icon-bubble';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    }).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function sincronizar(alFinalRecargar) {
    if (sincronizando) return;
    sincronizando = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var tieneDisparador = cart.items.some(function (i) {
          return i.variant_id === VARIANTE_DISPARADORA;
        });
        var lineaRegalo = null;
        cart.items.forEach(function (i) {
          if (i.variant_id === VARIANTE_REGALO && i.properties && i.properties._regalo_pack3) lineaRegalo = i;
        });

        if (tieneDisparador && !lineaRegalo) {
          return pedir('/cart/add.js', {
            items: [{ id: VARIANTE_REGALO, quantity: 1, properties: { _regalo_pack3: 'true' } }],
          }).then(function (res) {
            res && (alFinalRecargar ? location.reload() : pintarCarrito(res.sections));
          });
        }
        if (!tieneDisparador && lineaRegalo) {
          return pedir('/cart/change.js', { id: lineaRegalo.key, quantity: 0 }).then(function (res) {
            res && (alFinalRecargar ? location.reload() : pintarCarrito(res.sections));
          });
        }
      })
      .catch(function () {})
      .then(function () {
        sincronizando = false;
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      sincronizar(false);
    });
  }
  if (location.pathname === '/cart') sincronizar(true);
})();
